export enum ReportPeriod {
  CUSTOM = 'CUSTOM',
  TODAY = 'TODAY',
  THIS_MONTH = 'THIS_MONTH',
  LAST_MONTH = 'LAST_MONTH',
  LAST_3_MONTHS = 'LAST_3_MONTHS',
  LAST_6_MONTHS = 'LAST_6_MONTHS',
  LAST_12_MONTHS = 'LAST_12_MONTHS',
}

export type ReportInterval = {
  startDate: string
  endDate: string
}

export type ReportIntervalInput = {
  period: ReportPeriod
  startDate: Date | null
  endDate: Date | null
}

export type MonthlyReservationsReport = {
  month: string
  payPerPlayReservations: number
  membershipReservations: number
}
